$(function() {
  // let cartCurrency = window.Shopify.currency.active;
  // let subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
  // if((subdomain === 'www' || subdomain === 'sheepinc') && cartCurrency === 'USD') {
  //   $('.archive-sales').hide();
  // }


  $('div.customMenuItem:not(.site-header__cart)').on('click', function(e) {
    if($(e.target).closest('.customSubMenu').length == 0) {
      $(this).toggleClass('opened');
    }
  });
});

$('.sub-menu a').hover(function(){
  var hover_target = $(this).attr('attr-hover');
  if (hover_target) {
    $('#'+hover_target).siblings().removeClass('active');
    $('#'+hover_target).addClass('active');
  }
});

$('.sub-ul > .sub-li.children').click(function(){
  var parent1 = $(this).parents().find('.mobile-li.children.open');
  var text1 = $(this).find('a').html();
  $(this).children('a').hide();
  $(parent1).children('a').append('<span> '+text1+'</span>');
  $(parent1).addClass('children-active');

  $(this).parent().children('li').hide();
  $(this).show();
});

$('li.children').hover(function(){
  $(this).find('.lazyloadhover').each(function() {
    var $this = $(this);
    if(!$this.attr('src') && $this.data('src')) {
      $this.attr('src', $this.data('src'));
    }
  });
});

$('li.children > a').click(function(){
  $(this).parent().find('a').show();
  if ($(this).parent().hasClass('open') == false) {
    $(this).parent().addClass('open');
    $('.mobile-menu-ul > li.children').hide();
    $('.mobile-menu-ul > li.children.open').show();
  } else {
    if ($(this).parent().hasClass('children-active') == true) {
      $(this).parent().find('.open').removeClass('open');
    } else {
      $(this).parent().removeClass('open');
      $('.mobile-menu-ul > li.children').show();
    }
  }
});

$('.mobile-menu-ul > li.children > a').click(function(){
  $(this).children('span').remove();
  $(this).parent().removeClass('children-active');
  $('.sub-li').show();
});



$('.headerSearchContainer > img.searchIcon').click(function(){
  $container = $(this).closest('.headerSearchContainer');
  $('.searchInput').val('');
  if($container.hasClass('active')){
    $container.removeClass('active');
    $(this).attr('aria-expanded', 'false');
  }else{
    $container.addClass('active');
    $(this).attr('aria-expanded', 'true');
    $container.find('.searchContainer .searchInput').focus();
  }
});

// Keyboard support: the toggle is an <img role="button">, so Enter/Space must
// be wired manually; Esc closes the open search and returns focus to the toggle.
$('.headerSearchContainer > img.searchIcon').on('keydown', function(e){
  if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
    e.preventDefault();
    $(this).trigger('click');
  }
});
$('.headerSearchContainer .searchContainer .searchInput').on('keydown', function(e){
  if(e.key === 'Escape'){
    var $container = $(this).closest('.headerSearchContainer');
    if($container.hasClass('active')){
      e.preventDefault();
      $container.removeClass('active');
      $container.find('> img.searchIcon').attr('aria-expanded', 'false').focus();
    }
  }
});
$('.searchContainer > .searchCancel').on('keydown', function(e){
  if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
    e.preventDefault();
    $(this).trigger('click');
  }
});
$('.mobile-menu-sub-container .headerSearchContainer .searchInput').click(function(){
  $recents = $('.mobile-menu-sub-container .searchBoxItemsContainer.searchBoxRecents');
  $suggestions = $('.mobile-menu-sub-container .searchBoxItemsContainer.searchBoxSuggestions');
  if(!$suggestions.hasClass('active') && !$recents.hasClass('active')){
    $recents.addClass('active');
    $('.mobile-menu-sub-container').addClass('search-active');
  }
});
$('.searchContainer > .searchCancel').click(function(){
  var $container = $(this).closest('.headerSearchContainer');
  $container.removeClass('active');
  $container.find('> img.searchIcon').attr('aria-expanded', 'false').focus();
  $('.mobile-menu-sub-container').removeClass('search-active');
  $('.mobile-menu-sub-container .searchBoxItemsContainer').removeClass('active');
  $('.searchInput').val('');
  $('.mobile-menu-sub-container .headerSearchContainer .searchBox .searchContainer .searchCancel').hide();
});

$('.searchContainer').on('submit', function(e) {

  let val = $(this).find('.searchInput').val();

  if(val == null || val.length === 0) {
    return false;
  }

  let searchString = localStorage.getItem('recentSearchItems');
  let searchItems = [];
  if(searchString != null) {
    searchItems = JSON.parse(searchString);
  }

  searchItems.push({name: val, link: 'https://'+requestHost+'/search?q=' + val});

  if(searchItems.length > 5) {
    searchItems.shift();
  }

  localStorage.setItem('recentSearchItems', JSON.stringify(searchItems));
  localStorage.setItem('recentSearchSaved', 'false');

  return true;
});

$(function() {
  let searchString = localStorage.getItem('recentSearchItems');
  let searchItems = [];
  if(searchString != null) {
    searchItems = JSON.parse(searchString);
  }

  //dummy popular items
  let popularSearchItems = [
    {'name': 'Trousers & Shorts', 'link': 'https://'+requestHost+'/collections/womens-trousers-shorts'},
    {'name': 'Cardigans', 'link': 'https://'+requestHost+'/collections/womens-cardigans'},
    {'name': 'Crewnecks', 'link': 'https://'+requestHost+'/collections/womens-crewneck-collection'},
    {'name': 'T-Shirts & Polos', 'link': 'https://'+requestHost+'/collections/womens-t-shirts-polos'},
  ];


  if(searchItems.length === 0) {
    // $('.searchBoxRecents').addClass('disabled');


    for(let i = popularSearchItems.length - 1; i >= 0; i--) {
      $('.searchBoxRecents .searchBoxItems.popular').append('<a href="'+popularSearchItems[i].link+'">'+popularSearchItems[i].name+'</a>');
    }
    $('.searchBoxItemsTitle.recent').addClass('disabled');
    $('.searchBoxItems.recent').addClass('disabled');
    $('.searchBoxItemsTitle.popular').removeClass('disabled');
    $('.searchBoxItems.popular').removeClass('disabled');
  }else{

    $('.searchBoxItemsTitle.recent').removeClass('disabled');
    $('.searchBoxItems.recent').removeClass('disabled');
    // $('.searchBoxItemsTitle.popular').addClass('disabled');
    // $('.searchBoxItems.popular').addClass('disabled');
    for(let i = searchItems.length - 1; i >= 0; i--) {
      $('.searchBoxRecents .searchBoxItems.recent').append('<a href="'+searchItems[i].link+'">'+searchItems[i].name+'</a>');
    }
    for(let i = popularSearchItems.length - 1; i >= 0; i--) {
      $('.searchBoxRecents .searchBoxItems.popular').append('<a href="'+popularSearchItems[i].link+'">'+popularSearchItems[i].name+'</a>');
    }
  }

  $('.mobileSearchButton').on('click', function() {
    if(!$('body').hasClass('navigation-open')){
      $('.site-header__navigation').click();
      $('.searchInput').click();
    }
    // if($(this).hasClass('active')) {
    //   $('body').css('overflow', 'auto');
    //   $('.searchBox').removeClass('active');
    // } else {
    //   let headerHeight = $('.site-header').height();
    //   $('.mobileSearchBox').css({
    //     top: headerHeight + 'px',
    //     'min-height': 'calc(100vh - ' + headerHeight + 'px)',
    //     'max-height': 'calc(100vh - ' + headerHeight + 'px)',
    //     height: 'calc(100vh - '+headerHeight+'px)'
    //   });
    //
    //   $('body').css('overflow', 'hidden');
    //   $('.searchBox').addClass('active');
    //   $('.searchBox').addClass('slideIn');
    // }
    // $(this).toggleClass('active');
  });
  $('body').on('click', '.site-header__navigation', function(e) {
    if($('body').hasClass('navigation-open')){
      $('.mobile-menu-sub-container').removeClass('search-active');
      $('.mobile-menu-sub-container .searchBoxItemsContainer').removeClass('active');
    }
    $('.searchBox').removeClass('active');
    $('.mobileSearchButton').removeClass('active');
  });

  // $('.site-header__navigation').on('click', function() {
  // });
});

$(function() {

  let searchItems = [];
  let searchItemNames = {};
  let $menuContainer = $('.header-menu, .site-footer');

  $menuContainer.find('a').each(function() {
    let $item = $(this);
    let name = $item.html().trim();
    let link = $item.attr('href');

    if(!(name in searchItemNames) && link !== '#' && !name.includes('<')) {
      searchItems.push({"name": name, "link": link});
      searchItemNames[name] = undefined;
    }
  });
  for (i = 0; i < filter_styles.length; i++) {
    let style = filter_styles[i];
    if (style["active"]){
      let name = style["name"];
      let link = 'https://'+requestHost+'/collections/womens-all?filter.v.availability=1&filter.p.m.custom.style_v=' + style["key"];
      if(!(name in searchItemNames)) {
        searchItems.push({"name": name, "link": link});
        searchItemNames[name] = undefined;
      }
    }
  }

  let headerSearchFuse = new Fuse(searchItems, {
    isCaseSensitive: false,
    // includeScore: false,
    shouldSort: true,
    includeMatches: false,
    // findAllMatches: false,
    // minMatchCharLength: 1,
    // location: 0,
    // threshold: 0.6,
    // distance: 100,
    // useExtendedSearch: false,
    // ignoreLocation: false,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,
    keys: [
      "name"
    ]
  });

  $.get('https://api.sheepinc.com/api/search/terms', function(data) {
    let tempSearchItems = searchItems;
    searchItemNames = {};
    searchItems = [];

    data.forEach(function(e) {
      let link = new URL(e.url);

      if(link.hostname.includes('sheepinc.com')) {
        link.hostname = requestHost;
      }

      searchItems.push({"name": e.term, "link": link.href});
      searchItemNames[e.term] = undefined;
    });

    tempSearchItems.forEach(function(e) {
      let name = e.name;
      let link = e.link;
      if(!(name in searchItemNames)) {
        searchItems.push({"name": name, "link": link});
      }
    });

    headerSearchFuse = new Fuse(searchItems, {
      isCaseSensitive: false,
      shouldSort: true,
      includeMatches: false,
      keys: [
        "name"
      ]
    });
  })

  $('.searchInput').keyup(function(e) {
    let code = (e.keyCode ? e.keyCode : e.which);
    switch (code) {
      case 40: //down key
      case 38: //up key
        //add more cases for special buttons
        return;
    }

    let val = $(this).val();

    if(val.length === 0) {
      $('.searchBoxRecents').addClass('active');
      $('.searchBoxSuggestions').removeClass('active');
      $('.mobile-menu-sub-container .headerSearchContainer .searchContainer .searchCancel').hide();
      return;
    }else{
      $('.mobile-menu-sub-container .headerSearchContainer .searchContainer .searchCancel').show();
    }

    $('.searchBoxPLPLink').attr('href', 'https://'+requestHost+'/search?q=' + encodeURIComponent(val));
    $('.searchBoxPLPText').html(val);

    let suggestions = [];
    let fuseQuery = headerSearchFuse.search(val);

    for(let j = 0; j < fuseQuery.length; j++) {
      if(j > 5) {
        break;
      }
      suggestions.push(fuseQuery[j].item);
    }

    if(suggestions.length > 0) {
      let $itemsContainer = $('.searchBoxSuggestions .searchBoxItems:not(.plp)');
      $itemsContainer.html('');
      suggestions.forEach(function (item) {
        let $elem = $('<a href="'+item.link+'">'+item.name+'</a>');
        $elem.on('click', function(e) {

          let searchString = localStorage.getItem('recentSearchItems');
          let searchItems = [];
          if(searchString != null) {
            searchItems = JSON.parse(searchString);
          }

          searchItems.push(item);

          if(searchItems.length > 5) {
            searchItems.shift();
          }

          localStorage.setItem('recentSearchItems', JSON.stringify(searchItems));
          localStorage.setItem('recentSearchSaved', 'false');

          return true;
        });
        $itemsContainer.append($elem);
      });
      $('.searchBoxRecents').removeClass('active');
      $('.searchBoxSuggestions').addClass('active');
    } else {
      $('.searchBoxRecents').addClass('active');
      $('.searchBoxSuggestions').removeClass('active');
    }
  });

});